import { takeLatest, put } from "redux-saga/effects";

import { canvasDetailsActions } from "actions/canvasDetailsActions.js";

import { GET_DATA } from "actions/apiOperations.js";
import { PATCH_DATA } from "actions/apiOperations.js";

export const requestCanvasDetails = function* (action) {
  const { buyplanId, recipent, subject, body } = action.payload;

  yield put({
    type: GET_DATA,
    path: `/api/buyplans/${buyplanId}/canvas_details`,
    actions: canvasDetailsActions,
    params: { recipent: recipent, subject: subject, content: body },
  });
};

export const updateCanvasDetails = function* (action) {
  const { buyplanId, canvasURL } = action.payload;

  yield put({
    type: PATCH_DATA,
    path: `/api/buyplans/${buyplanId}/canvas_details`,
    actions: canvasDetailsActions,
    params: { canvas_url: canvasURL },
  });
};

export const watchCanvasDetails = function* () {
  yield takeLatest(
    canvasDetailsActions.request,
    requestCanvasDetails
  );
};

export const watchUpdateCanvasDetails = function* () {
  yield takeLatest(
    canvasDetailsActions.update,
    updateCanvasDetails
  );
};
